import { Component, Input, OnDestroy, OnInit, ChangeDetectorRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import moment from 'moment-timezone';
import { Subscription } from 'rxjs/internal/Subscription';
import { Moment } from 'moment';
import { SystemService } from '../../../../../../system/system.service';
import { FieldConfigDTO } from '../../../../../../system/system-dtos';
import { DataTypeComponent } from '../../../data-type-component';

@Component({
  selector: 'app-form-field-date',
  templateUrl: './date-form-field.component.html',
  styleUrls: ['./date-form-field.component.scss'],
  standalone: false,
})
export class DateFormFieldComponent extends DataTypeComponent implements OnDestroy, OnInit {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  private dateFormat = 'YYYY-MM-DD';

  public modelDate: Moment;

  public timezone: string;

  public formattedDate: string;

  editReadOnly: boolean = false;

  public timezoneSubscription: Subscription;

  constructor(
    private systemService: SystemService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    super();
  }

  getInitialData() {
    return this.data;
  }

  ngOnDestroy() {
    if (this.timezoneSubscription) {
      this.timezoneSubscription.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.timezoneSubscription = this.systemService.systemTimeZoneSubject.subscribe((timezone: string) => {
      this.timezone = timezone;
      this.formatDate();
      this.onModelChange();
      this.changeDetectorRef.detectChanges();
    });

    if (this.formGroup !== undefined) {
      this.editReadOnly = this.formGroup.get(this.fieldConfig.name).disabled;
    }
  }

  formatDate(): void {
    // this.modelDate = moment(this.data, this.dateFormat);

    if (this.fieldConfig.dateFormat) {
      this.dateFormat = this.fieldConfig.dateFormat;
    }
    if (!this.data) {
      return;
    }

    this.modelDate = moment.utc(this.data, 'YYYY-MM-DD');
    this.formattedDate = this.modelDate.format(this.dateFormat);
    if (this.formGroup) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format(this.dateFormat));
    }
  }

  onModelChange() {
    if (this.modelDate) {
      this.modelDate.utcOffset(0, true);
      this.modelDate = moment.utc(this.modelDate.toDate(), 'YYYY-MM-DD');
    }
    // this.modelDate = this.modelDate.tz(this.getTimezone());
    if (this.formGroup && this.modelDate) {
      this.formGroup.get(this.fieldConfig.name).setValue(this.modelDate.format('YYYY-MM-DD'));
    }
  }
}
